import styled, { keyframes } from 'styled-components'

export const RegistersStyle = styled.section`
  display: flex;
  width: 100%;
  background: #f5f5f5;
  padding: 69px 0 220px;

  > div {
    flex-direction: column;
  }
`

export const RegisterMenu = styled.div`
  display: flex;
  width: 262px;
  background: #fff;
  margin-right: 30px;
  padding-top: 20px;

  a {
    display: flex;
    width: 100%;
    height: 53px;
    color: #65987c !important;
    font-size: 16px;
    background: #f5f5f5;
    align-items: center;
    padding-left: 15px;
    border-left: 4px solid #65987c;
  }
`

export const Title = styled.h2`
  font-size: 24px;
  margin-top: 25px;
  font-family: 'Poppins', sans-serif;
`

export const SubTitle = styled.h3`
  display: inline-block;
  font-size: 18px;
  font-family: 'Poppins', sans-serif;
`

const StatusBlink = keyframes`
  0% { box-shadow: 0 0 15px #23B218; }
  50% { box-shadow: none; }
  100% { box-shadow: 0 0 15px #23B218; }
`

const StatusBlinkError = keyframes`
  0% { box-shadow: 0 0 15px red; }
  50% { box-shadow: none; }
  100% { box-shadow: 0 0 15px red; }
`

export const List = styled.div`
  font-family: 'Poppins', sans-serif;
  padding: 15px 30px 30px 30px;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 1px 4px #15223214;
  border-radius: 6px;

  table {
    width: 100%;
    margin-top: 23px;

    thead {
      background: #65987c 0% 0% no-repeat padding-box;

      td {
        color: #fff;
        font-size: 12px;
        padding: 12px 0;
        letter-spacing: 0.87px;
        text-align: center;
        text-transform: uppercase;
      }
    }

    tbody {
      position: relative;
      td {
        height: 48px;
        font-size: 14px;
        line-height: 19px;
        text-align: center;
        letter-spacing: 0.2px;

        span {
          display: flex;
          width: 10px;
          height: 10px;
          background: #23b218;
          margin: 0 auto;
          border-radius: 50%;
          animation: ${StatusBlink} 1.5s linear infinite;

          &.error {
            background: red;
            animation: ${StatusBlinkError} 1.5s linear infinite;
          }
        }
      }
      tr:nth-child(even) {
        background: #f5f5f5;
      }
      button {
        width: 73px;
        height: 29px;
        color: #65987c;
        font: normal normal 600 12px Poppins;
        letter-spacing: 0.87px;
        text-transform: uppercase;
        background: #fff;
        border: 1px solid #65987c;
        border-radius: 4px;
      }
    }
  }

  .align-title-table {
    display: flex;
    justify-content: space-between;
  }
`

export const RegistersFilters = styled.div`
  display: flex;
  width: fit-content;
  margin: 16px 0 33px 0;
  font-family: 'Poppins', sans-serif;
`

export const TotalRegisters = styled.div`
  display: flex;
  width: 156px;
  height: 77px;
  font-size: 16px;
  background: #fff;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  box-shadow: 0px 1px 4px #15223214;
  border-radius: 6px;

  span {
    font-size: 24px;
  }
`

export const InputDate = styled.div`
  display: flex;
  height: 77px;
  align-items: center;
  margin: 16px 0 0 30px;

  label {
    display: flex;
    align-items: center;
    background: #fff;
    padding: 10px;
    margin: 0 10px 0 0;

    span {
      margin-right: 10px;
    }
    input {
      width: 200px;
    }
  }

  .btn--download {
    display: flex;
    height: 40px;
    color: #fff;
    background: #49a4da;
    padding: 0 10px;
    margin-left: 10px;
    align-items: center;
    text-decoration: none;
    cursor: pointer;
  }
`

export const Filters = styled.div`
  display: flex;
`

export const ButtonFilter = styled.div`
  display: flex;
  height: 40px;
  color: #fff;
  padding: 0 10px;
  background: #65987c;
  align-items: center;
  cursor: pointer;
`

export const ResendButton = styled.button`
  padding: 0 10px;
  height: 40px;
  position: absolute;
  right: 0px;
  top: 20px;
  outline: none;
  border: none;
  background-color: #65987c;
  color: white;
  font-size: 14px;

  &:disabled {
    opacity: 0.4;
  }
`

export const Loading = styled.div`
  display: flex;
  height: 300px;
  justify-content: center;

  img {
    width: 100px;
  }
`

export const Paginating = styled.div`
  display: inline-block;

  span {
    margin-right: 20px;
    padding: 5px;
    cursor: pointer;
  }
`

/*
MODAL
*/

export const ContainerModal = styled.div`
  position: fixed;
  background-color: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(2px);
  top: 0px;
  left: 0px;
  width: 100vw;
  height: 100vh;
  z-index: 999;

  display: flex;
  align-items: center;
  justify-content: center;
`
export const ContentModal = styled.div`
  padding: 40px;
  width: 80%;
  background: white;

  > p {
    font-size: 18px;
  }

  > div {
    padding: 0px;

    overflow: auto;
    max-height: 400px;
  }
`

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 20px;

  > button {
    border: none;
    padding: 10px 20px;
  }

  .loader {
    margin-top: 0px;
  }
`

export const ButtonConfirm = styled.button`
  margin-left: 20px;
  background: #65987c;
  color: white;
`
export const ButtonBack = styled.button``
